var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniEsf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uniEsf-top-section {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1534.631 -1620.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3895",
    transform: "translate(1536.631 1622.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3834",
    transform: "translate(8.25 12.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3766",
    transform: "translate(9.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-2",
    d: "M1602.965,1664.036c.482-.047.575.08.5.282-2.042,1.645-2.489,4.179-2.489,10.955v5.708h-1.233V1668.1a.543.543,0,1,0-1.075,0v12.878h-1.233v-5.708c0-6.775-.447-9.31-2.489-10.955-.073-.2.02-.33.5-.282Z",
    transform: "translate(-1594.911 -1664.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-2",
    d: "M1600.958,1680.963H1599.7v-12.893a.551.551,0,0,0-.531-.6.538.538,0,0,0-.515.6v12.893h-1.262v-5.723a36.793,36.793,0,0,0-.478-7.4,5.729,5.729,0,0,0-2.005-3.545l0,0v0a.216.216,0,0,1,.009-.216c.066-.085.232-.113.508-.086h7.513c.275-.027.441,0,.507.086a.217.217,0,0,1,.009.216v0l0,0a5.729,5.729,0,0,0-2,3.545,36.784,36.784,0,0,0-.478,7.4Zm-1.233-.029h1.2v-5.693a36.819,36.819,0,0,1,.479-7.4,5.758,5.758,0,0,1,2.012-3.559.188.188,0,0,0-.006-.184c-.059-.075-.221-.1-.482-.075h-7.516c-.262-.026-.425,0-.483.075a.188.188,0,0,0-.006.184,5.757,5.757,0,0,1,2.012,3.559,36.8,36.8,0,0,1,.479,7.4v5.693h1.2v-12.864a.566.566,0,0,1,.544-.634.579.579,0,0,1,.56.634Z",
    transform: "translate(-1594.877 -1663.978)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3768",
    transform: "translate(16.303 2.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-2",
    d: "M1622.144,1673.874c-1.712-.738-4.979.48-4.641,4.14v6.356a5.016,5.016,0,0,1,1.124-1.375l-.044-4.641a.531.531,0,0,1,1.053-.015v3.648a4.265,4.265,0,0,1,1.965-1l-.042-5.561c-.013-.294-.075-.717.284-.97.281-.2.561-.412.3-.577Z",
    transform: "translate(-1617.464 -1673.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-2",
    d: "M1617.455,1684.389v-6.408a3.875,3.875,0,0,1,1.463-3.664,3.675,3.675,0,0,1,1.643-.662,2.959,2.959,0,0,1,1.555.173h0a.2.2,0,0,1,.11.158c0,.141-.192.291-.41.444a.889.889,0,0,0-.283.874c0,.029,0,.057,0,.083l.042,5.574-.012,0a4.237,4.237,0,0,0-1.958,1l-.024.02v-3.68a.51.51,0,0,0-.479-.44.5.5,0,0,0-.545.456l.044,4.647-.005,0a5.036,5.036,0,0,0-1.121,1.372Zm3.591-10.737a3.674,3.674,0,0,0-2.112.689,3.848,3.848,0,0,0-1.451,3.639v6.3a4.993,4.993,0,0,1,1.095-1.329l-.044-4.636h0a.524.524,0,0,1,.577-.481.533.533,0,0,1,.5.469v3.616a4.257,4.257,0,0,1,1.936-.984l-.042-5.549c0-.026,0-.054,0-.083a.924.924,0,0,1,.295-.9c.2-.143.4-.293.4-.419a.169.169,0,0,0-.1-.133A2.684,2.684,0,0,0,1621.047,1673.651Z",
    transform: "translate(-1617.431 -1673.621)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3770",
    transform: "translate(6.267 2.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-2",
    d: "M1584.557,1673.874c1.712-.738,4.979.48,4.641,4.14v6.356a5.016,5.016,0,0,0-1.124-1.375l.044-4.641a.531.531,0,0,0-1.053-.015v3.648a4.266,4.266,0,0,0-1.965-1l.042-5.561c.013-.294.075-.717-.284-.97-.281-.2-.561-.412-.3-.577Z",
    transform: "translate(-1584.439 -1673.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M1589.179,1684.389l-.027-.045a5.032,5.032,0,0,0-1.121-1.372l-.005,0,.044-4.647a.5.5,0,0,0-.545-.456.509.509,0,0,0-.479.44v3.68l-.024-.021a4.239,4.239,0,0,0-1.958-1l-.012,0v-.012l.042-5.561c0-.027,0-.055,0-.084a.89.89,0,0,0-.283-.874c-.218-.154-.414-.3-.41-.444a.2.2,0,0,1,.11-.158h0a2.961,2.961,0,0,1,1.555-.173,3.675,3.675,0,0,1,1.643.662,3.876,3.876,0,0,1,1.463,3.665Zm-1.124-1.435a4.992,4.992,0,0,1,1.095,1.329v-6.3a3.849,3.849,0,0,0-1.451-3.64,3.408,3.408,0,0,0-3.169-.487.169.169,0,0,0-.1.133c0,.126.195.276.4.419a.924.924,0,0,1,.3.9c0,.029,0,.057,0,.083l-.042,5.549a4.255,4.255,0,0,1,1.936.984v-3.616a.533.533,0,0,1,.5-.469.523.523,0,0,1,.577.481v0h0Z",
    transform: "translate(-1584.406 -1673.622)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3772",
    transform: "translate(4.458 4.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-2",
    d: "M1578.569,1685.322v-4.7c-.257-.745.316-.547.562-.325a2.789,2.789,0,0,1,.769,2.247v2.779Z",
    transform: "translate(-1578.489 -1680.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M1579.879,1685.3h-1.36v-4.713c-.093-.271-.087-.443.019-.513.141-.093.42.041.567.174a2.6,2.6,0,0,1,.766,2.094c0,.056.005.11.008.163Zm-1.33-.03h1.3v-2.765c0-.052-.005-.107-.008-.163a2.583,2.583,0,0,0-.755-2.073c-.137-.124-.405-.256-.532-.172-.092.061-.094.227-.006.481v4.691Z",
    transform: "translate(-1578.454 -1680.047)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3774",
    transform: "translate(21.352 4.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M1635.425,1685.322v-4.7c.257-.745-.316-.547-.562-.325a2.789,2.789,0,0,0-.769,2.247v2.779Z",
    transform: "translate(-1634.08 -1680.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-2",
    d: "M1635.407,1685.3h-1.359v-2.794l.008-.164a2.6,2.6,0,0,1,.766-2.094c.146-.132.426-.267.567-.173.105.07.111.242.019.513Zm-1.33-.03h1.3v-4.691c.088-.254.085-.42-.006-.481-.127-.084-.4.048-.532.171a2.583,2.583,0,0,0-.756,2.074c0,.056-.005.11-.008.164Z",
    transform: "translate(-1634.047 -1680.047)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3776",
    transform: "translate(15.858 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-2",
    d: "M1616.037,1706.089c2.405-6.773,6.827-7.219,10.077-4.244.478.437.193.734-.46.5-3.15-.385-4.653,1.545-5.979,3.722h-1.338c.764-1.357,1.1-2.548,3.136-3.743.346-.2,0-.851-.5-.648-2.028.816-2.95,2.463-3.6,4.411Z",
    transform: "translate(-1616.016 -1700.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-2",
    d: "M1617.338,1706.071h-1.37l.007-.02a12.316,12.316,0,0,1,2.268-4.1,5.078,5.078,0,0,1,7.833-.154c.211.193.29.373.218.493-.084.14-.355.153-.691.034-3.178-.387-4.689,1.623-5.964,3.715l0,.007h-1.371l.012-.022c.128-.227.245-.451.357-.668a6.476,6.476,0,0,1,2.784-3.079.3.3,0,0,0,.091-.408.44.44,0,0,0-.58-.214,6.425,6.425,0,0,0-3.588,4.4Zm-1.328-.029h1.307a6.443,6.443,0,0,1,3.6-4.41.469.469,0,0,1,.617.228.326.326,0,0,1-.1.446,6.449,6.449,0,0,0-2.772,3.068c-.109.21-.222.427-.346.647h1.3a9.9,9.9,0,0,1,2.3-2.818,4.854,4.854,0,0,1,3.684-.9h0c.323.115.581.107.657-.021.064-.106-.016-.276-.212-.456a5.5,5.5,0,0,0-5.043-1.615C1619.548,1700.572,1617.492,1701.881,1616.01,1706.041Z",
    transform: "translate(-1615.968 -1700.047)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3778",
    transform: "translate(1.229 10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-2",
    d: "M1578.191,1706.089c-2.405-6.773-6.827-7.219-10.077-4.244-.478.437-.193.734.46.5,3.15-.385,4.653,1.545,5.979,3.722h1.338c-.764-1.357-1.1-2.548-3.136-3.743-.346-.2,0-.851.5-.648,2.027.816,2.95,2.463,3.6,4.411Z",
    transform: "translate(-1567.86 -1700.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-2",
    d: "M1578.177,1706.071h-1.37l0-.01a6.424,6.424,0,0,0-3.588-4.4.44.44,0,0,0-.58.214.3.3,0,0,0,.091.408,6.477,6.477,0,0,1,2.784,3.079c.113.217.23.441.357.668l.012.022h-1.371l0-.007c-1.275-2.092-2.785-4.1-5.964-3.715-.336.119-.607.106-.691-.034-.072-.121.007-.3.218-.493a5.078,5.078,0,0,1,7.833.154,12.313,12.313,0,0,1,2.268,4.1Zm-1.348-.029h1.307c-1.483-4.16-3.539-5.469-5-5.834a5.5,5.5,0,0,0-5.043,1.615c-.2.18-.276.351-.212.456.077.128.335.136.657.021h0a4.854,4.854,0,0,1,3.685.9,9.907,9.907,0,0,1,2.3,2.818h1.3c-.123-.22-.236-.437-.346-.647a6.45,6.45,0,0,0-2.773-3.068.326.326,0,0,1-.1-.446.469.469,0,0,1,.617-.228A6.443,6.443,0,0,1,1576.829,1706.041Z",
    transform: "translate(-1567.826 -1700.047)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3780",
    transform: "translate(15.176 17.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M1613.774,1722.8l.01,1.292h3.523c.634.143.866.456.889.794h-4.422v2.467h6.251c.538-.041.424-.394.418-.794-.023-1.66-1.355-3.734-3.224-3.759Z",
    transform: "translate(-1613.759 -1722.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M1613.74,1727.33h-.015v-2.5h4.42c-.033-.379-.335-.643-.874-.765h-3.536l-.011-1.321h3.46a3.019,3.019,0,0,1,2.315,1.272,4.329,4.329,0,0,1,.923,2.5c0,.059,0,.118.007.174.018.322.033.6-.439.635Zm.015-.029h6.236c.442-.033.428-.285.411-.6,0-.056-.006-.115-.007-.175-.024-1.748-1.4-3.72-3.209-3.744h-3.43l.01,1.262h3.512c.709.16.881.528.9.808v.016h-4.423Z",
    transform: "translate(-1613.725 -1722.748)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3782",
    transform: "translate(12.622 17.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-2",
    d: "M1607.622,1723.478a1.079,1.079,0,1,1-1.079-1.079,1.079,1.079,0,0,1,1.079,1.079Z",
    transform: "translate(-1605.42 -1722.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-2",
    d: "M1606.443,1724.5a1.123,1.123,0,1,1,1.123-1.123A1.124,1.124,0,0,1,1606.443,1724.5Zm0-2.158a1.035,1.035,0,1,0,1.035,1.035A1.037,1.037,0,0,0,1606.443,1722.342Z",
    transform: "translate(-1605.32 -1722.254)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3784",
    transform: "translate(5.596 17.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-2",
    d: "M1588.928,1722.8l-.011,1.292h-3.523c-.635.143-.866.456-.889.794h4.422v2.467h-6.251c-.537-.041-.424-.394-.418-.794.023-1.66,1.356-3.734,3.224-3.759Z",
    transform: "translate(-1582.23 -1722.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-2",
    d: "M1588.909,1727.33h-6.266c-.473-.036-.458-.314-.44-.635,0-.057.006-.115.007-.174a4.329,4.329,0,0,1,.923-2.5,3.02,3.02,0,0,1,2.315-1.272h3.46v.015l-.011,1.306h-3.536c-.539.122-.841.387-.875.765h4.421Zm-3.46-4.553c-1.807.024-3.185,2-3.21,3.744,0,.06,0,.119-.007.175-.018.319-.031.571.412.6h6.235v-2.438h-4.423v-.016c.019-.28.19-.648.9-.808h3.512l.01-1.262Z",
    transform: "translate(-1582.197 -1722.748)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3786",
    transform: "translate(20.317 13.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-2",
    d: "M1630.711,1712.763c1.326-2.5,3.174-3.546,5.5-3.475a1.452,1.452,0,0,1,1.505,1.421,5.294,5.294,0,0,0-5.979,2.927,2,2,0,0,0-1.028-.873Z",
    transform: "translate(-1630.69 -1709.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-2",
    d: "M1631.691,1713.632l-.013-.02a1.963,1.963,0,0,0-1.02-.868l-.017-.005.008-.015c1.28-2.418,3.084-3.557,5.516-3.483a1.521,1.521,0,0,1,1.1.44,1.663,1.663,0,0,1,.418.995l0,.019-.019,0a5.285,5.285,0,0,0-5.964,2.92Zm-1.008-.91a1.988,1.988,0,0,1,1.006.854,5.3,5.3,0,0,1,5.964-2.916,1.44,1.44,0,0,0-1.489-1.39C1633.75,1709.2,1631.957,1710.325,1630.683,1712.721Z",
    transform: "translate(-1630.641 -1709.237)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3788",
    transform: "translate(0 13.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-2",
    d: "M1570.843,1712.763c-1.326-2.5-3.174-3.546-5.5-3.475a1.452,1.452,0,0,0-1.505,1.421,5.293,5.293,0,0,1,5.979,2.927A2,2,0,0,1,1570.843,1712.763Z",
    transform: "translate(-1563.82 -1709.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-2",
    d: "M1569.777,1713.632l-.012-.021a5.285,5.285,0,0,0-5.964-2.92l-.019,0,0-.019a1.667,1.667,0,0,1,.418-.995,1.521,1.521,0,0,1,1.1-.44c2.431-.074,4.235,1.065,5.515,3.483l.008.016-.017.005a1.963,1.963,0,0,0-1.02.868Zm-4.811-3.057a5.165,5.165,0,0,1,4.813,3,1.988,1.988,0,0,1,1.006-.854c-1.274-2.4-3.067-3.525-5.481-3.452a1.44,1.44,0,0,0-1.489,1.39A8.3,8.3,0,0,1,1564.966,1710.574Z",
    transform: "translate(-1563.782 -1709.237)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3790",
    transform: "translate(11.97 21.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-2",
    d: "M1603.271,1735.765l1.417-1.81c.33-.458.315-.423.639,0l1.435,1.81a1.629,1.629,0,0,0-1.553.854c-.207.442-.182.352-.387,0a1.631,1.631,0,0,0-1.551-.854Z",
    transform: "translate(-1603.241 -1733.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-2",
    d: "M1604.954,1736.9c-.044,0-.076-.058-.139-.174-.022-.039-.046-.083-.074-.133a1.617,1.617,0,0,0-1.538-.847h-.03l1.436-1.834c.167-.232.245-.335.328-.336h0c.078,0,.146.089.28.266l.054.07,1.453,1.834h-.03a1.616,1.616,0,0,0-1.54.847c-.105.225-.147.3-.2.306Zm-1.722-1.182a1.636,1.636,0,0,1,1.534.861c.029.05.053.094.075.133.05.092.087.158.113.158h0c.035,0,.089-.111.173-.291a1.636,1.636,0,0,1,1.536-.862l-1.416-1.787-.054-.07c-.125-.164-.194-.255-.257-.255h0c-.068,0-.147.106-.3.324Z",
    transform: "translate(-1603.172 -1733.575)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path3816",
    transform: "translate(1.608 1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-2",
    d: "M1559.077,1628.121v2.783a17.664,17.664,0,0,0-2.433.651l-1.391-2.41-5.841,3.373,1.393,2.414a17.882,17.882,0,0,0-1.779,1.779l-2.414-1.393-3.373,5.841,2.41,1.391a17.652,17.652,0,0,0-.651,2.432h-2.783v6.745H1545a17.666,17.666,0,0,0,.651,2.433l-2.41,1.391,3.373,5.841,2.414-1.393a17.882,17.882,0,0,0,1.779,1.779l-1.393,2.414,5.841,3.373,1.391-2.41a17.6,17.6,0,0,0,2.433.651v2.783h6.746v-2.783a17.586,17.586,0,0,0,2.433-.651l1.391,2.41,5.841-3.373-1.393-2.414a17.891,17.891,0,0,0,1.779-1.779l2.414,1.393,3.373-5.841-2.41-1.391a17.614,17.614,0,0,0,.651-2.433h2.783v-6.745H1579.9a17.6,17.6,0,0,0-.651-2.432l2.41-1.391-3.373-5.841-2.414,1.393a17.891,17.891,0,0,0-1.779-1.779l1.393-2.414-5.841-3.373-1.391,2.41a17.654,17.654,0,0,0-2.433-.651v-2.783Zm1.772,1.643h3.2v2.787a15.777,15.777,0,0,1,4.918,1.315l1.392-2.411,2.771,1.6-1.394,2.414a15.972,15.972,0,0,1,3.6,3.6l2.414-1.393,1.6,2.77-2.411,1.392a15.778,15.778,0,0,1,1.315,4.919h2.787v3.2h-2.787a15.778,15.778,0,0,1-1.315,4.919l2.411,1.392-1.6,2.77-2.413-1.393a15.974,15.974,0,0,1-3.6,3.6l1.393,2.414-2.771,1.6-1.392-2.411a15.78,15.78,0,0,1-4.918,1.315v2.787h-3.2v-2.787a15.78,15.78,0,0,1-4.918-1.315l-1.392,2.411-2.771-1.6,1.394-2.414a15.972,15.972,0,0,1-3.6-3.6l-2.414,1.393-1.6-2.77,2.411-1.392a15.781,15.781,0,0,1-1.314-4.919h-2.787v-3.2h2.787a15.781,15.781,0,0,1,1.314-4.919l-2.411-1.392,1.6-2.77,2.413,1.393a15.974,15.974,0,0,1,3.6-3.6l-1.393-2.414,2.771-1.6,1.392,2.411a15.777,15.777,0,0,1,4.918-1.315v-2.787Z",
    transform: "translate(-1542.126 -1628.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-2",
    d: "M1565.618,1668.476h-6.746l-.089-.089v-2.71a17.806,17.806,0,0,1-2.3-.616l-1.355,2.346-.122.032-5.841-3.373-.033-.121,1.357-2.35a17.994,17.994,0,0,1-1.684-1.684l-2.35,1.357-.121-.033-3.373-5.841.032-.121,2.347-1.355a17.816,17.816,0,0,1-.616-2.3h-2.71l-.089-.089v-6.745l.089-.089h2.71a17.81,17.81,0,0,1,.616-2.3l-2.347-1.355-.032-.122,3.373-5.841.121-.032,2.35,1.356a17.994,17.994,0,0,1,1.684-1.684l-1.357-2.35.033-.121,5.841-3.373.122.032,1.355,2.346a17.806,17.806,0,0,1,2.3-.616v-2.71l.089-.089h6.746l.089.089v2.71a17.835,17.835,0,0,1,2.3.616l1.355-2.346.122-.032,5.841,3.373.032.121-1.357,2.35a18.027,18.027,0,0,1,1.685,1.684l2.35-1.356.122.032,3.373,5.841-.033.122-2.346,1.355a17.812,17.812,0,0,1,.616,2.3h2.71l.089.089v6.745l-.089.089h-2.71a17.817,17.817,0,0,1-.616,2.3l2.346,1.355.033.121-3.373,5.841-.122.033-2.35-1.357A18.027,18.027,0,0,1,1574,1661.6l1.357,2.35-.032.121-5.841,3.373-.122-.032-1.355-2.346a17.8,17.8,0,0,1-2.3.616v2.71Zm-6.657-.178h6.568V1665.6l.072-.088a17.622,17.622,0,0,0,2.42-.647l.106.04,1.347,2.333,5.687-3.284-1.349-2.337.019-.111a17.858,17.858,0,0,0,1.77-1.77l.112-.019,2.336,1.349,3.284-5.687-2.333-1.347-.04-.106a17.561,17.561,0,0,0,.647-2.42l.087-.072h2.695v-6.568H1579.7l-.087-.072a17.561,17.561,0,0,0-.647-2.42l.04-.106,2.333-1.347-3.284-5.687-2.336,1.349-.112-.019a17.872,17.872,0,0,0-1.77-1.77l-.019-.111,1.349-2.337-5.687-3.284-1.347,2.333-.106.039a17.622,17.622,0,0,0-2.42-.647l-.072-.088v-2.694h-6.568v2.694l-.072.088a17.594,17.594,0,0,0-2.42.647l-.106-.039-1.347-2.333-5.687,3.284,1.349,2.337-.019.111a17.885,17.885,0,0,0-1.77,1.77l-.111.019-2.337-1.349-3.284,5.687,2.333,1.347.039.106a17.648,17.648,0,0,0-.647,2.42l-.087.072H1542.1v6.568h2.695l.087.072a17.648,17.648,0,0,0,.647,2.42l-.039.106-2.333,1.347,3.284,5.687,2.337-1.349.111.019a17.872,17.872,0,0,0,1.77,1.77l.019.111-1.349,2.337,5.687,3.284,1.347-2.333.106-.04a17.594,17.594,0,0,0,2.42.647l.072.088Zm-.089-37.6h0Zm4.972,36.132h-3.2l-.089-.089v-2.707a15.846,15.846,0,0,1-4.792-1.281l-1.352,2.342-.122.032-2.771-1.6-.032-.122,1.354-2.344a16.027,16.027,0,0,1-3.508-3.508l-2.344,1.353-.121-.032-1.6-2.771.032-.121,2.341-1.352a15.853,15.853,0,0,1-1.281-4.793h-2.707l-.089-.089v-3.2l.089-.089h2.707a15.854,15.854,0,0,1,1.281-4.793l-2.341-1.352-.032-.122,1.6-2.771.121-.032,2.344,1.353a16.022,16.022,0,0,1,3.508-3.508l-1.353-2.344.032-.121,2.771-1.6.122.033,1.352,2.341a15.852,15.852,0,0,1,4.792-1.281v-2.707l.089-.089h3.2l.089.089v2.707a15.854,15.854,0,0,1,4.792,1.281l1.352-2.341.122-.032,2.771,1.6.033.122-1.354,2.344a16.021,16.021,0,0,1,3.508,3.508l2.344-1.353.122.032,1.6,2.771-.032.122-2.341,1.352a15.865,15.865,0,0,1,1.281,4.793h2.707l.089.089v3.2l-.089.089h-2.707a15.864,15.864,0,0,1-1.281,4.793l2.341,1.352.032.121-1.6,2.771-.122.032-2.344-1.353a16.024,16.024,0,0,1-3.508,3.508l1.353,2.344-.033.121-2.771,1.6-.122-.032-1.352-2.342a15.847,15.847,0,0,1-4.792,1.281v2.707Zm-3.111-.178h3.022v-2.7l.08-.088a15.684,15.684,0,0,0,4.891-1.307l.113.037,1.348,2.334,2.617-1.51-1.349-2.337.025-.116a15.858,15.858,0,0,0,3.58-3.58l.117-.025,2.336,1.349,1.511-2.616-2.334-1.348-.037-.114a15.678,15.678,0,0,0,1.307-4.891l.089-.08h2.7v-3.021h-2.7l-.089-.08a15.678,15.678,0,0,0-1.307-4.891l.037-.114,2.334-1.348-1.511-2.616-2.337,1.349-.117-.025a15.852,15.852,0,0,0-3.58-3.58l-.025-.116,1.349-2.337-2.617-1.51-1.348,2.334-.113.036a15.7,15.7,0,0,0-4.891-1.307l-.08-.088v-2.7h-3.022v2.7l-.08.088a15.7,15.7,0,0,0-4.891,1.307l-.113-.036-1.348-2.334-2.617,1.51,1.349,2.337-.025.116a15.848,15.848,0,0,0-3.58,3.58l-.117.025-2.336-1.349-1.511,2.616,2.334,1.348.037.114a15.681,15.681,0,0,0-1.307,4.891l-.088.08h-2.7v3.021h2.7l.088.08a15.681,15.681,0,0,0,1.307,4.891l-.037.114-2.334,1.348,1.511,2.616,2.336-1.349.117.025a15.858,15.858,0,0,0,3.58,3.58l.025.116-1.349,2.337,2.617,1.51,1.348-2.334.113-.037a15.683,15.683,0,0,0,4.891,1.307l.08.088Zm-.089-34.307h0Z",
    transform: "translate(-1541.922 -1627.829)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3832",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-2",
    d: "M1558.563,1666.4a21.863,21.863,0,1,1,8.537-1.724A21.794,21.794,0,0,1,1558.563,1666.4Zm0-42.984a21.053,21.053,0,1,0,21.053,21.053A21.077,21.077,0,0,0,1558.563,1623.416Z",
    transform: "translate(-1536.631 -1622.538)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text3849",
    transform: "translate(7.725 7.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3859",
    transform: "translate(26.042 10.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-2",
    d: "M1648.632,1682.478a.225.225,0,0,0,.127-.092l.691-.975.428.261-.7.986a.729.729,0,0,1-.408.3q-.659.176-.858-.571l-.132-.495a.966.966,0,0,1,.23-.84l.4.231q-.021.005-.083.146a.423.423,0,0,0-.044.27l.152.57q.064.242.2.206Z",
    transform: "translate(-1647.753 -1681.054)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3861",
    transform: "translate(25.563 8.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-2",
    d: "M1646.356,1677.3l-.178-.437,2.284-.932.178.437Z",
    transform: "translate(-1646.178 -1675.927)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3863",
    transform: "translate(24.981 7.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-2",
    d: "M1646.023,1673.31l-.21-.425.425-.21.21.425Zm-1.281-.19-.479.237.2.414q.252.509.837.22a1.929,1.929,0,0,0,.578-.663l-.442-.257-.268.389a.229.229,0,0,1-.083.077q-.115.057-.19-.1Z",
    transform: "translate(-1644.263 -1672.675)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3865",
    transform: "translate(23.136 5.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-2",
    d: "M1641.114,1665.423l-.249-.341-.348.253.249.341Zm-.31-.425-.246-.338-.348.253.246.338Zm.557-.088-.253-.348-.343.25.253.348Zm-2.52.349a.588.588,0,0,1-.582-.27l-.068-.094.432-.314.047.065a.32.32,0,0,0,.15.131.325.325,0,0,0,.263-.088l.432-.314.278.382q-.675.491-.466.777.127.175.4-.022l.4-.294.286.393a2.925,2.925,0,0,0-.391.322q-.237.256-.107.434t.368-.015l.438-.319.278.382a1.53,1.53,0,0,0-.508.5.317.317,0,0,0,.064.319l.065.089-.432.314-.067-.092a.621.621,0,0,1-.068-.611.524.524,0,0,1-.524-.2.7.7,0,0,1-.106-.618.46.46,0,0,1-.3-.057.691.691,0,0,1-.234-.206.58.58,0,0,1-.109-.292.479.479,0,0,1,.062-.3Z",
    transform: "translate(-1638.191 -1664.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3867",
    transform: "translate(21.711 2.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-2",
    d: "M1634.184,1658.207a.4.4,0,0,0,.13.081c.064.023.11.018.141-.015a.377.377,0,0,0,.086-.157l.211-.774a.593.593,0,0,1,.124-.246.323.323,0,0,1,.421-.05l1.144.568-.109.39-.981-.511c-.065-.034-.114-.032-.147,0a.208.208,0,0,0-.04.088l-.188.733a.786.786,0,0,0,.242.831l.083.075-.359.4-.084-.077a1.015,1.015,0,0,1-.242-.334.563.563,0,0,1-.047-.4.7.7,0,0,1-.743-.205l-.323-.293.359-.4Zm1.141-1.594,1.245.626-.087.259-1.233-.616Z",
    transform: "translate(-1633.502 -1656.613)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3869",
    transform: "translate(21.217 2.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-2",
    d: "M1632.447,1656.5l-.339-.238a.516.516,0,0,1-.229-.5,1.133,1.133,0,0,1,.222-.538l.932-1.326.386.272-.836,1.188a.791.791,0,0,0-.152.307.293.293,0,0,0,.153.284l.169.119Z",
    transform: "translate(-1631.877 -1653.891)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3871",
    transform: "translate(19.431 1.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-2",
    d: "M1627.541,1654.737a.537.537,0,0,1-.484.311,1.119,1.119,0,0,1-.558-.145.883.883,0,0,1-.466-.49.831.831,0,0,1,.086-.663.814.814,0,0,1,.378-.367.547.547,0,0,1,.513-.007,1.155,1.155,0,0,1,.476.585.883.883,0,0,1,.055.777Zm-.45-.28a.391.391,0,0,0-.056-.36.608.608,0,0,0-.218-.257.169.169,0,0,0-.167.012.3.3,0,0,0-.124.126.286.286,0,0,0,0,.274.44.44,0,0,0,.2.2q.291.151.365.009Z",
    transform: "translate(-1625.998 -1653.314)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3873",
    transform: "translate(15.074 0.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-2",
    d: "M1612.793,1650.283q.9-.883,1.5-.757a.634.634,0,0,1,.433.334.763.763,0,0,1,.09.546.9.9,0,0,1-.406.635.8.8,0,0,1-.589.088l-.862-.18a.615.615,0,0,1-.531-.432.557.557,0,0,1-.215.18.787.787,0,0,1-.44,0l-.115-.024.109-.523.084.018q.26.054.308-.175l.115-.549.472.1-.083.4a.389.389,0,0,0,.127.339Zm1.095.308q.409.086.481-.257a.248.248,0,0,0-.05-.217.34.34,0,0,0-.2-.12.608.608,0,0,0-.415.1,3.622,3.622,0,0,0-.487.356Z",
    transform: "translate(-1611.66 -1649.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3875",
    transform: "translate(13.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-2",
    d: "M1608.417,1647.328l-.474-.018.018-.474.474.018Zm.444,1.617-.11,0a.539.539,0,0,1-.287-.1.533.533,0,0,1-.2-.233.51.51,0,0,1-.511.293l-.252-.009.02-.534.092,0q.286.01.3-.311l.02-.526.472.018-.01.27q-.021.578.394.593l.092,0Z",
    transform: "translate(-1607.503 -1646.836)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3877",
    transform: "translate(12.091 0.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-2",
    d: "M1603.673,1650.239l-.163.013a.848.848,0,0,1-.434-.1,1.16,1.16,0,0,1-.234-.144.853.853,0,0,1-.612.35l-.343.027-.042-.533.15-.012a1.2,1.2,0,0,0,.444-.1,3.451,3.451,0,0,1-.294-.219.472.472,0,0,1-.193-.283q-.014-.18.3-.317a1.451,1.451,0,0,1,.462-.123.8.8,0,0,1,.384.054.333.333,0,0,1,.222.29.432.432,0,0,1-.023.194,2.206,2.206,0,0,1-.187.324.447.447,0,0,0,.313.068l.211-.017Z",
    transform: "translate(-1601.843 -1648.791)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3879",
    transform: "translate(10.655 0.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-2",
    d: "M1598.174,1647.7l-.414.083-.084-.418.414-.083Zm-.559.112-.414.083-.084-.418.414-.083Zm1.09,1.518-.108.022a.568.568,0,0,1-.548-.208.511.511,0,0,1-.429.4l-.247.049-.1-.524.09-.018q.28-.056.217-.372l-.1-.516.463-.093.053.265q.114.567.522.485l.09-.018Z",
    transform: "translate(-1597.117 -1647.279)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3881",
    transform: "translate(8.23 1.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-2",
    d: "M1591.9,1653.4l-.125.049a.8.8,0,0,1,.063.341,1.215,1.215,0,0,1-.413.778,2.255,2.255,0,0,1-.756.485.989.989,0,0,1-1.428-.678,1.851,1.851,0,0,1-.106-.616l.436-.029a1.548,1.548,0,0,0,.1.441.6.6,0,0,0,.876.372,1.291,1.291,0,0,0,.828-.672.089.089,0,0,0,0-.064.064.064,0,0,0-.07-.037q-.181,0-.877.1l-.044-.453,1.323-.518Z",
    transform: "translate(-1589.136 -1652.901)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3883",
    transform: "translate(5.547 1.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-2",
    d: "M1582.089,1655.406l-.39.267-1.393-2.037.39-.266Z",
    transform: "translate(-1580.307 -1653.37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3885",
    transform: "translate(3.735 3.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-2",
    d: "M1575.326,1660.213q-.2-1.246.247-1.665a.634.634,0,0,1,.522-.162.761.761,0,0,1,.5.241.9.9,0,0,1,.284.7.8.8,0,0,1-.267.531l-.644.6a.616.616,0,0,1-.659.185.554.554,0,0,1,.023.28.787.787,0,0,1-.25.362l-.086.081-.365-.391.063-.059q.195-.181.035-.353l-.382-.41.353-.329.277.3a.331.331,0,0,0,.164.089.335.335,0,0,0,.187,0Zm.882-.717q.306-.285.067-.541a.249.249,0,0,0-.206-.084.338.338,0,0,0-.213.1.608.608,0,0,0-.16.4,3.623,3.623,0,0,0,.01.6Z",
    transform: "translate(-1574.345 -1658.382)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3887",
    transform: "translate(1.958 5.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-2",
    d: "M1569.828,1666.21a.156.156,0,0,0-.155-.019.267.267,0,0,0-.126.1q-.136.186.009.292a.267.267,0,0,0,.2.039.409.409,0,0,0,.164-.056.35.35,0,0,0,.006-.171A.272.272,0,0,0,1569.828,1666.21Zm.112,1.532-.431-.315.309-.423a.635.635,0,0,1-.519-.094.567.567,0,0,1-.255-.407.668.668,0,0,1,.15-.463.554.554,0,0,1,.868-.174.6.6,0,0,1,.2.257.388.388,0,0,1,.044.218l.3-.417.431.315-.19.26a.913.913,0,0,1-.281.229.858.858,0,0,1-.263.115,1.11,1.11,0,0,1-.033.293.972.972,0,0,1-.149.357Zm-.781-2.018-.28.383-.383-.28.28-.383Z",
    transform: "translate(-1568.497 -1665.445)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3889",
    transform: "translate(1.54 7.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-2",
    d: "M1569.047,1672.109l-.055.1a.926.926,0,0,0-.1.284q-.033.2.082.262c.063.034.153.011.27-.071q.052-.038.23-.2l.343.359a1.478,1.478,0,0,1-1.5.447.4.4,0,0,1-.063.291l-.057.106-.47-.253.039-.072q.136-.254-.086-.373l-.555-.3.225-.418.8.43a1.066,1.066,0,0,0,.388.136.734.734,0,0,1-.143-.4.769.769,0,0,1,.092-.418l.092-.171Z",
    transform: "translate(-1567.123 -1671.856)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3891",
    transform: "translate(0 8.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-2",
    d: "M1564.724,1676.689l-.151.386a.516.516,0,0,1-.435.341,1.134,1.134,0,0,1-.576-.088l-1.509-.591.172-.44,1.353.529a.79.79,0,0,0,.334.075.293.293,0,0,0,.239-.216l.075-.192Z",
    transform: "translate(-1562.054 -1676.298)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3893",
    transform: "translate(0.279 10.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-2",
    d: "M1564.291,1681.229a1.354,1.354,0,0,1,.705.4,1.191,1.191,0,0,1,.287,1.143,1.1,1.1,0,0,1-.487.735,1.133,1.133,0,0,1-.876.139,2.5,2.5,0,0,1-.458-.181l.188-.387a1.721,1.721,0,0,0,.339.107.6.6,0,0,0,.507-.1.727.727,0,0,0,.271-.448.8.8,0,0,0-.086-.61.749.749,0,0,0-.509-.333,1.7,1.7,0,0,0-.665.057l-.175-.457A1.569,1.569,0,0,1,1564.291,1681.229Zm-.758.987-.1.462-.462-.1.1-.462Z",
    transform: "translate(-1562.973 -1681.183)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path3853",
    transform: "translate(9.587 9.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "uniEsf-top-section",
    d: "M1568.179,1664.309a12.477,12.477,0,0,1,24.65-.254",
    transform: "translate(-1568.179 -1653.644)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniEsf);
export default __webpack_public_path__ + "static/media/uniEsf.540a1ef8dc9b139e6ee45eea64f24492.svg";
export { ForwardRef as ReactComponent };